import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  DomainGrid,
  useGetDomainCounts
} from "../../../common/dynamicanalysis";
import { Title } from "../../../../../../components/dynamicanalysis";
import LoadingAndErrorBoundary from "../../../../../commons/LoadingAndErrorBoundary";
import { LoadingIndicator } from "../../../../../../components";
import { JoeDomains, JoeDomainsCount } from "../../../../@types";
import { items } from "./items";

const Domains = () => {
  const { hash, uploadId } = useParams();
  const { data } = useGetDomainCounts<JoeDomainsCount>(hash, "joe", uploadId);

  return (
    <>
      <Title headingLevel="h1" title="Domains/IPs/URLs" />
      <Tabs defaultActiveKey={Object.keys(items)[0]} mountOnEnter unmountOnExit>
        {Object.entries(items).map(([key, { title, schema, errorMsg }]) => (
          <Tab
            key={key}
            eventKey={key}
            title={`${title} (${
              (data && data[key as keyof JoeDomainsCount]) || 0
            })`}
          >
            <LoadingAndErrorBoundary
              errorFallback={() => <div>{errorMsg}</div>}
              suspenseFallback={
                <LoadingIndicator data-testid={`${key}-loading-indicator`} />
              }
            >
              <DomainGrid<JoeDomains>
                schema={schema}
                type={key as JoeDomains}
                analysis="joe"
              />
            </LoadingAndErrorBoundary>
          </Tab>
        ))}
      </Tabs>
    </>
  );
};

export default Domains;
